import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instancekg84gatwz31z as RequestHook_instance,
  TransformRequestBodyHook_instance124n1iui3hxhd as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance1qpxtjyk29394 as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.u5m_1 = key;
        this.v5m_1 = client;
        this.w5m_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.x5m_1 = ArrayList().p2();
        var tmp_0 = this;
        tmp_0.y5m_1 = ClientPluginBuilder$onClose$lambda;
      }
      c5s(block) {
        this.z5m(RequestHook_instance, block);
      }
      n5u(block) {
        this.z5m(TransformRequestBodyHook_instance, block);
      }
      f5q(block) {
        this.z5m(TransformResponseBodyHook_instance, block);
      }
      z5m(hook, handler) {
        this.x5m_1.i2(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
